import React from 'react';
import { caseSignals, openQuestions } from '../../data/content';
import { SectionCTA } from '../SectionCTA';
export function PainSection() {
  return <section className="w-full bg-white px-4 py-16 sm:px-6 sm:py-20" data-id="element-296" data-mp="2wg1bkwwxkjfq">
      <div className="mx-auto max-w-4xl" data-id="element-297" data-mp="2rhreuhvk5as0">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-flag" data-id="element-298" data-mp="2mjycjzxdl0x0">
          When a complex DVO case sits in your chair…
        </p>
        <h2 className="mt-3 text-center font-display text-3xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-299" data-mp="2hmg1a2vvy9lu">
          Do you have a repeatable workflow to follow?
        </h2>

        <p className="mt-8 text-center text-sm font-bold uppercase tracking-[0.1em] text-ink-muted" data-id="element-300" data-mp="28tmjnysyuy4t">
          A patient presents with:
        </p>

        <ul className="mx-auto mt-4 grid max-w-2xl gap-2.5 sm:grid-cols-2" data-id="element-301" data-mp="23rnd6g1xjl3n">
          {caseSignals.map((signal, i) => <li key={signal} className={`flex items-start gap-3 rounded-xl bg-cream px-4 py-3 text-[15px] font-medium text-ink ${i === caseSignals.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-302" data-mp="1tvkfpni0wan1" data-mpi={i}>
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-navy-600 text-[10px] font-bold text-white" data-id="element-303" data-mp="1ektvftb0h2cc">
                {i + 1}
              </span>
              {signal}
            </li>)}
        </ul>

        <p className="mx-auto mt-8 max-w-xl text-center text-[15px] leading-relaxed text-ink-soft" data-id="element-304" data-mp="1sj0moqlgg431">
          And suddenly, multiple clinical variables need to be organized at the same time.
        </p>

        <div className="mx-auto mt-8 grid max-w-3xl gap-2.5 sm:grid-cols-2" data-id="element-305" data-mp="1ilvyymbyo0k4">
          {openQuestions.map(q => <p key={q} className="rounded-xl border border-navy-100 bg-navy-50 px-4 py-3 font-display text-[15.5px] italic leading-snug text-navy-700" data-id="element-306" data-mp="1niw5szgmx7ca">
              “{q}”
            </p>)}
        </div>

        <div className="mx-auto mt-10 max-w-2xl space-y-3 text-center text-[15px] leading-relaxed text-ink-soft" data-id="element-307" data-mp="2erfq7tdxz2t4">
          <p data-id="element-308" data-mp="29scl68xyowl5">This is where even experienced dentists can feel uncertain.</p>
          <p data-id="element-309" data-mp="251w6ymmbh6xq">Not necessarily because they lack knowledge.</p>
          <p className="font-semibold text-ink" data-id="element-310" data-mp="250b9op8mb9w6">
            But because complex cases require multiple variables to be organized in the right
            sequence.
          </p>
          <p data-id="element-311" data-mp="1v4rlyq47jhii">
            That’s why Dr. Karito created the{' '}
            <strong className="font-bold text-navy-600" data-id="element-312" data-mp="1r2czlw1bxzmh">DVO Clinical Workflow Builder™</strong> — a
            practical system that turns scattered clinical information into a repeatable
            case-planning workflow in 30 minutes.
          </p>
        </div>

        <SectionCTA transformation="Turn scattered information into a sequence you can follow." label="Get my DVO Workflow Builder™" subline="One payment of $27 · Instant access" data-id="element-313" data-mp="1h61mx4xtv7ri" />
      </div>
    </section>;
}